import { useState } from 'react'
import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { ProjectShareLinksPanel } from '@/components/project-share-links-panel'

/** Opens the customer's tracker portal links in a dialog. */
export function TrackerPortalButton({ projectId }: { projectId: string }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button variant="ghost" size="sm" className="h-7 px-2 text-xs" onClick={() => setOpen(true)}>
        <ExternalLink className="mr-1 h-3.5 w-3.5" /> Tracker portal
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>Tracker portal</DialogTitle>
          </DialogHeader>
          {open && <ProjectShareLinksPanel projectId={projectId} embedded />}
        </DialogContent>
      </Dialog>
    </>
  )
}
